<h2 mat-dialog-title>Download images</h2>
<mat-dialog-content class="downloadPopup">
  <div>
    <p>
      {{ dialogData.exports !== 0 ? 'Download a zip file of images for the Vertical, North, South, East, and West orientations of this location with image details.' : 'You have no exports available for your team, contact the administrator to load more' }}
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button matButton="elevated"  (click)="onNoClick()" [mat-dialog-close]="true">Cancel</button>
  <button matButton="filled"  [mat-dialog-close]="true" [disabled]="dialogData.exports === 0">Download</button>
</mat-dialog-actions>
